//
// Copyright 2024 DXOS.org
//
/**
 * @deprecated Use `invariant` instead?
 */
// TODO(burdon): Use consistently.
export const assertParameter = (parameterName, condition, expected) => {
    if (!condition) {
        throw new TypeError(`Parameter \`${parameterName}\` is invalid. Expected ${expected}.`);
    }
};
//# sourceMappingURL=parameter.js.map